import { Box, Typography } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import { useTranslation } from 'react-i18next';
import { useMaterialUIController } from 'context';
import { getCrmColors } from '@layouts/pages/CRM/kanban-board/crm-theme';

export type ImportStep = 'file' | 'columns' | 'review' | 'done';

const STEPS: { key: ImportStep; label: string }[] = [
    { key: 'file', label: 'people.importar.etapaArquivo' },
    { key: 'columns', label: 'people.importar.etapaColunas' },
    { key: 'review', label: 'people.importar.etapaConferencia' },
    { key: 'done', label: 'people.importar.etapaResultado' },
];

/// Onde a pessoa está na importação: só indica; voltar é pelos botões, para não pular a conferência.
/// Colunas só aparece quando está no caminho: mostrar uma etapa pulada faria parecer que faltou algo.
export const ImportSteps = ({ current, withColumns }: { current: ImportStep; withColumns: boolean }) => {
    const { t } = useTranslation();
    const [controller] = useMaterialUIController();
    const cc = getCrmColors(controller.darkMode);

    const steps = STEPS.filter((step) => withColumns || step.key !== 'columns');
    const position = steps.findIndex((step) => step.key === current);

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap' }}>
            {steps.map((step, index) => {
                const done = index < position;
                const active = index === position;

                return (
                    <Box key={step.key} sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                        {index > 0 && (
                            <Box sx={{ width: 32, height: 2, background: done || active ? cc.accent : cc.border }} />
                        )}
                        <Box
                            sx={{
                                width: 30,
                                height: 30,
                                borderRadius: '50%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: 13,
                                fontWeight: 700,
                                background: done || active ? cc.accent : 'transparent',
                                border: `2px solid ${done || active ? cc.accent : cc.border}`,
                                color: done || active ? '#fff' : cc.textMuted,
                            }}
                        >
                            {done ? <CheckIcon sx={{ fontSize: '16px !important' }} /> : index + 1}
                        </Box>
                        <Typography
                            sx={{
                                fontSize: 14,
                                fontWeight: active ? 700 : 500,
                                color: active ? cc.textPrimary : cc.textSecondary,
                            }}
                        >
                            {t(step.label)}
                        </Typography>
                    </Box>
                );
            })}
        </Box>
    );
};
